import { toast } from '@huspy/forge/shared';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { proposalApi } from '@modules/proposals/api';

const useRequestDigitalProposalPdf = () => {
  const { t } = useTranslation();
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['requestDigitalProposalPdf'],
    mutationFn: ({ html }:
    { html: string }) => proposalApi.requestDigitalProposalPdf(html),
    onError: (res) => {
      toast('error', { message: res.message ?? t('proposals.notifications.failedToGenerateProposalPdf') });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useRequestDigitalProposalPdf;
